import { render, staticRenderFns } from "./browserBlock.vue?vue&type=template&id=73e7b806&scoped=true"
import script from "./browserBlock.vue?vue&type=script&lang=js"
export * from "./browserBlock.vue?vue&type=script&lang=js"
import style0 from "./browserBlock.vue?vue&type=style&index=0&id=73e7b806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e7b806",
  null
  
)

export default component.exports